import { ITenantBids } from 'app/shared/model/tenant-bids.model';

export interface ITenantBidItem {
  id?: string;
  stockId?: string | null;
  name?: string | null;
  qty?: number;
  chargedMrp?: number;
  discount?: number | null;
  manufacDate?: number;
  expDate?: number;
  cgst?: number | null;
  sgst?: number | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  bid?: ITenantBids | null;
  tenantBids?: ITenantBids | null;
}

export const defaultValue: Readonly<ITenantBidItem> = {
  active: false,
};
